import ImageSlider from "../components/ImageSlider";

const Seciont1 = () => {
  return (
    <div>
      <ImageSlider></ImageSlider>
    </div>
  );
};

export default Seciont1;